<template>
  <v-page-content>
    <h3>Уведомления</h3>
    <div>
      <b-card class="notifications__notificationCard" :class="note.isRead ? '' : 'notification-unread'" v-for="(note, index) in notes" :key="index">
        <div class="notifications__notification">
          <div>
            <div v-html="note.text"></div>
            <span class="notifications__notificationDatetime">
              {{ note.createdAt | moment('HH:mm:ss, DD MMMM') }}
            </span>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <b-button v-if="notes.length < totalNots" @click="showMore" class="notifications__moreButton" variant="outline-primary">
        Показать еще <span v-if="unreadNots > 0">({{ unreadNots }})</span>
      </b-button>
    </div>
  </v-page-content>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

import notesApi from '@/api/notifications'

export default {
  name: 'Notifications',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('notifications', {
      notes: 'getNots',
      currentPage: 'getCurrentPage',
      totalNots: 'getTotal',
      unreadNots: 'getUnreadNots'
    })
  },
  created() {
    this.fetchNots()
    notesApi.notificationsMakeRead(this.notes.filter((el) => el.isRead === false).map((el) => el.id))
      .then(() => {
        this.fetchUnreadNots()
        this.fetchLatestNots()
      })
  },
  mounted() {
    this.fetchNots()
  },
  beforeDestroy() {
    this.changePage(1)
    this.clearNots()
  },
  methods: {
    showMore() {
      this.changePage(this.currentPage + 1).then(() => {
        this.fetchNots().then(() => {
          notesApi.notificationsMakeRead(this.notes.filter((el) => el.isRead === false).map((el) => el.id))
            .then(() => {
              this.fetchUnreadNots()
              this.fetchLatestNots()
              this.fetchNots()
            })
        })
      })
    },
    ...mapActions('notifications', [
      'fetchNots',
      'changePage',
      'fetchLatestNots',
      'fetchUnreadNots',
      'clearNots'
    ])
  }
}
</script>

<style lang="scss">

@import "../../sass/vendor/bootstrap/variables";

.notifications__notificationStatus {
  height: 100%;
  float: left;
  margin-right: 10px;
}

.notifications__moreButton {
  margin-top: 10px;
  width: 100%;
}

.notification-unread {
  background-color: $gray-200;
  font-weight: 500 !important;
}

.notifications__notificationCard {
  margin-bottom: 20px;
}

.notifications__notificationCard:last-child {
  margin-bottom: 10px;
}

.notification__link-success {
  color: #28a745;
}

.notification__link-danger {
  color: #dc3545;
}

</style>
